import { FileUploadStore } from '@sib/files';
import { useTranslation } from '@sib/i18n';
import { X } from '@sib/ui/icons';
import { FileManagerConfig } from '@sib/ui/types';
import { FileManager } from './FileManager';

interface FileManagerContentProps {
  closeDialog: () => void;
  fileUploadStore: FileUploadStore;
  config: FileManagerConfig;
}

export const FileManagerContent = ({
  closeDialog,
  fileUploadStore,
  config,
}: FileManagerContentProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex">
        <p className="text-primary my-auto w-full justify-center text-center text-xl font-semibold">
          {t('fileManager.uploadFiles')}
        </p>
        <button
          onClick={closeDialog}
          className="cursor-pointer"
          aria-label="Close"
        >
          <X className="text-primary h-[18px] w-[18px]" />
        </button>
      </div>
      <FileManager
        closeFileManager={closeDialog}
        fileUploadStore={fileUploadStore}
        config={config}
      />
    </>
  );
};
